<template>
	<div>
		<!-- 面包屑导航区 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>题目管理</el-breadcrumb-item>
			<el-breadcrumb-item>题目列表</el-breadcrumb-item>
		</el-breadcrumb>

		<!-- 卡片视图 -->
		<el-card class="box-card">
			<!-- 搜索与添加 -->
			<el-row :gutter="20">
				<el-col :span="8">
					<!-- <el-input clearable @clear="getUserList" placeholder="请输入内容（问题内容）" v-model="queryInfo.query">
                            <el-button @click="getUserList" slot="append" icon="el-icon-search"></el-button>
                        </el-input> -->
				</el-col>
				<el-col :span="4">
					<el-button type="primary" @click="showAddDialog">添加考题</el-button>
				</el-col>
			</el-row>

			<!-- 考题列表 -->
			<el-table border stripe :data="userlist" style="width: 100%">
				<el-table-column type="index" label="#"></el-table-column>
				<el-table-column prop="username" label="一体机"></el-table-column>
				<el-table-column prop="ask" label="问题"></el-table-column>
				<el-table-column prop="A" label="A"></el-table-column>
				<el-table-column prop="B" label="B"></el-table-column>
				<el-table-column prop="C" label="C"></el-table-column>
				<el-table-column prop="D" label="D"></el-table-column>
				<el-table-column prop="answer" label="正确答案">
					<template slot-scope="scope">
						<div v-if="scope.row.answer == 1">A</div>
						<div v-else-if="scope.row.answer == 2">B</div>
						<div v-else-if="scope.row.answer == 3">C</div>
						<div v-else>D</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="180px">
					<template slot-scope="scope">
						<!-- 修改按钮 -->
						<el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)">
						</el-button>
						<!-- 删除 -->
						<el-button type="danger" icon="el-icon-delete" size="mini"
							@click="removeUserById(scope.row.id)"></el-button>
					</template>
				</el-table-column>
			</el-table>

			<!-- 分页 -->
			<div class="block">
				<!-- <span class="demonstration">完整功能</span> -->
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="queryInfo.pagenum" :page-sizes="[2, 5, 10, 15]" :page-size="queryInfo.pagesize"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>

		</el-card>

		<!-- 添加考题对话框 -->
		<el-dialog title="添加考题" :visible.sync="addDialogVisible" width="50%" @close="addDialogClosed">
			<!-- 内容主体区域 -->
			<el-form :model="addForm" ref="addFormRef" label-width="70px">
				<el-form-item label="一体机">
					<el-cascader v-model="addForm.username" :options="options" clearable>
					</el-cascader>
				</el-form-item>
				<el-form-item label="题型">
					<el-cascader v-model="addForm.classification" :options="optionTX" @change="optionTXChange" clearable>
					</el-cascader>
				</el-form-item>
				<el-form-item label="题目">
					<el-input v-model="addForm.ask"></el-input>
				</el-form-item>
				<el-form-item label="A">
					<el-input v-model="addForm.A"></el-input>
				</el-form-item>
				<el-form-item label="B">
					<el-input v-model="addForm.B"></el-input>
				</el-form-item>
				<el-form-item label="C">
					<el-input v-model="addForm.C"></el-input>
				</el-form-item>
				<el-form-item label="D">
					<el-input v-model="addForm.D"></el-input>
				</el-form-item>
				<el-form-item label="答案">
					<template v-if="questionType!==1">
						<el-radio v-model="addForm.answer" label="1">A</el-radio>
						<el-radio v-model="addForm.answer" label="2">B</el-radio>
						<el-radio v-model="addForm.answer" label="3">C</el-radio>
						<el-radio v-model="addForm.answer" label="4">D</el-radio>
					</template>
					<template v-if="questionType===1">
						<el-checkbox-group v-model="addForm.answer">
							<el-checkbox label="1">A</el-checkbox>
							<el-checkbox label="2">B</el-checkbox>
							<el-checkbox label="3">C</el-checkbox>
							<el-checkbox label="4">D</el-checkbox>
						</el-checkbox-group>
					</template>
					
				</el-form-item>
			</el-form>
			<!-- 底部区域 -->
			<div slot="footer" class="dialog-footer">
				<el-button @click="addDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="addUser">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 修改考题对话框 -->
		<el-dialog title="修改考题" :visible.sync="editDialogVisible" width="50%" @close="editDialogClosed">
			<!-- 内容主体区域 -->
			<el-form :model="editForm" ref="editFormRef" label-width="70px">
				<el-form-item label="题目">
					<el-input v-model="editForm.ask"></el-input>
				</el-form-item>
				<el-form-item label="A">
					<el-input v-model="editForm.A"></el-input>
				</el-form-item>
				<el-form-item label="B">
					<el-input v-model="editForm.B"></el-input>
				</el-form-item>
				<el-form-item label="C">
					<el-input v-model="editForm.C"></el-input>
				</el-form-item>
				<el-form-item label="D">
					<el-input v-model="editForm.D"></el-input>
				</el-form-item>
				<el-form-item label="答案">
					<template v-if="questionType!==1">
						<el-radio v-model="editForm.answer" label="1">A</el-radio>
						<el-radio v-model="editForm.answer" label="2">B</el-radio>
						<el-radio v-model="editForm.answer" label="3">C</el-radio>
						<el-radio v-model="editForm.answer" label="4">D</el-radio>
					</template>
					<template v-if="questionType===1">
						<el-checkbox-group v-model="editForm.answer">
							<el-checkbox label="1">A</el-checkbox>
							<el-checkbox label="2">B</el-checkbox>
							<el-checkbox label="3">C</el-checkbox>
							<el-checkbox label="4">D</el-checkbox>
						</el-checkbox-group>
					</template>
				</el-form-item>
			</el-form>
			<!-- 底部区域 -->
			<div slot="footer" class="dialog-footer">
				<el-button @click="editDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="editUser">确 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	export default {
		props: {
			classfy: String
		},
		data() {
			return {
				//   控制考题对话框的显示隐藏
				editDialogVisible: false,
				//   控制考题对话框的显示隐藏
				addDialogVisible: false,
				// 获取考题列表的参数对象
				queryInfo: {
					query: '',
					// 当前的页数
					pagenum: 1,
					// 当前每页显示多少数据
					pagesize: 5
				},
				editForm: {
					ask: '',
					A: '',
					B: '',
					C: '',
					D: '',
					answer: 0,
					username: '',
					classification: '',
				},
				// 添加考题的表单数据
				addForm: {
					username: '',
					classification: '',
					ask: '',
					A: '',
					B: '',
					C: '',
					D: '',
					answer: 0
				},
				userlist: [],
				total: 0,
				questionType: 0,//题型 0单选/判断 1多选 2填空
				options: [{
					value: 'hxsys',
					label: '化学实验室'
				}],
				optionTX: [{
						value: '单选题',
						label: '单选题'
					},
					{
						value: '判断题',
						label: '判断题'
					},
					{
						value: '多选题',
						label: '多选题'
					}
				]
			}
		},
		mounted() {
			
		},
		watch:{
			classfy(){
				this.queryInfo.pagenum = 1;
				this.queryInfo.pagesize = 5;
				this.queryInfo.query = this.classfy;
				
				this.getUserList();
				this.initOptions();
			}
		},
		methods: {
			//获取列表数据
			async getUserList() {
				console.log('this.queryInfo.query', this.queryInfo.query);
				const {
					data: res
				} = await this.$http.post('/subjectss', {
					params: this.queryInfo
				})
				
				for (const key in res.users) {
					res.users[key].username = this.options[0]['label'];
				}
				
				this.userlist = res.users
				this.total = res.totalpage
			},
			//初始化一体机选项
			initOptions(){
				let options = {};
				switch(this.classfy){
					case 'xsss':
						options = {value: 'xsss', label: '学生宿舍'};
					break;
					case 'xyjws':
						options = {value: 'xyjws', label: '校园警务室'};
					break;
					case 'jxl':
						options = {value: 'jxl', label: '教学楼安全'};
					break;
					case 'yjjy':
						options = {value: 'yjjy', label: '应急救援'};
					break;
					case 'wb':
						options = {value: 'wb', label: '网吧'};
					break;
					case 'xc':
						options = {value: 'xc', label: '校车安全'};
					break;
					case 'sd':
						options = {value: 'sd', label: '书店'};
					break;
					case 'wc':
						options = {value: 'wc', label: '重点车辆安全'};
					break;
					case 'kyz':
						options = {value: 'kyz', label: '客运车安全'};
					break;
					case 'spxzf':
						options = {value: 'spxzf', label: '食品加工小作坊'};
					break;
					case 'bld':
						options = {value: 'bld', label: '便民超市'};
					break;
					case 'cydcf':
						options = {value: 'cydcf', label: '餐饮店厨房'};
					break;
					case 'tzc':
						options = {value: 'tzc', label: '童装厂'};
					break;
					case 'czw':
						options = {value: 'czw', label: '居住出租屋'};
					break;
					case 'yjaq':
						options = {value: 'yjaq', label: '寄递安全'};
					break;
					case 'czw':
						options = {value: 'czw', label: '居住出租屋'};
					break;
					case 'tzsb':
						options = {value: 'tzsb', label: '特种设备'};
					break;
					case 'dg':
						options = {value: 'dg', label: '施工用电安全'};
					break;
					case 'gjaq':
						options = {value: 'gjaq', label: '国家安全'};
					break;
					case 'jzsgaq':
						options = {value: 'jzsgaq', label: '建筑工地安全'};
					break;
					case 'stzl':
						options = {value: 'stzl', label: '生态治理'};
					break;
					case 'rq':
						options = {value: 'rq', label: '燃气安全'};
					break;
					case 'aqsc':
						options = {value: 'aqsc', label: '生产车间'};
					break;
					case 'xj':
						options = {value: 'xj', label: '防范邪教'};
					break;
					case 'fank':
						options = {value: 'fank', label: '反恐防暴'};
					break;
					case 'weih':
						options = {value: 'weih', label: '危化企业'};
					break;
					case 'bmyd':
						options = {value: 'bmyd', label: '便民药店'};
					break;
					case 'hxsys':
						options = {value: "hxsys", label: '化学实验室'};
					break;
					default: break;
				}
				this.options = [options];
			},
			//显示添加题型对话框
			showAddDialog(){
				this.addDialogVisible = true;
			},
			//选择题型
			optionTXChange(value){
				this.setQuestionType(value);
			},
			setQuestionType(value){
				if(value.indexOf('多选题')!==-1){
					this.questionType = 1;
				}else{
					this.questionType = 0;
				}
				
				if(this.questionType===1){
					this.addForm.answer = [];
				}else{
					this.addForm.answer = 0;
				}
			},
			
			// 监听 pagesize 改变的事件
			handleSizeChange(newSize) {
				//   console.log(newSize)
				this.queryInfo.pagesize = newSize
				this.getUserList()
			},
			// 监听 页码值改变的事件
			handleCurrentChange(newpage) {
				//   console.log(newpage)
				this.queryInfo.pagenum = newpage
				this.getUserList()
			},
			// 监听添加考题对话框的关闭事件
			addDialogClosed() {
				this.$refs.addFormRef.resetFields()
			},

			// 添加按钮，添加新考题
			addUser() {
				this.$refs.addFormRef.validate(async valid => {
					if (!valid) return
					
					if(this.questionType===1){
						this.addForm.answer = this.addForm.answer.join(',')
					}
					
					let username = this.addForm.username;
					let classification = this.addForm.classification;
					if('object' == typeof(username)){
						this.addForm.username = username[0];
					}
					if('object' == typeof(classification)){
						this.addForm.classification = classification[0];
					}
					
					await this.$http.post('/subjectss/establish', this.addForm)
					this.$message.success('考题添加成功!')
					// 隐藏对话框
					this.addDialogVisible = false
					// 刷新
					this.getUserList()
				})
			},

			// 修改按钮
			editUser() {
				this.$refs.editFormRef.validate(async valid => {
					if (!valid) return
					
					if(this.questionType===1){
						this.editForm.answer = this.editForm.answer.join(',')
					}
					
					let username = this.editForm.username;
					let classification = this.editForm.classification;
					if('object' == typeof(username)){
						this.editForm.username = username[0];
					}
					if('object' == typeof(classification)){
						this.editForm.classification = classification[0];
					}
					
					await this.$http.post('/subjectss/modify/' + this.editForm.id, {
						ask: this.editForm.ask,
						A: this.editForm.A,
						B: this.editForm.B,
						C: this.editForm.C,
						D: this.editForm.D,
						answer: this.editForm.answer
					})
					this.$message.success('考题修改成功!')
					// 隐藏对话框
					this.editDialogVisible = false
					// 刷新
					this.getUserList()
				})
			},
			// 修改表单的验证规则对象
			async showEditDialog(id) {
				const {
					data
				} = await this.$http.get('/subjectss/' + id)
				this.editForm = data[0]
				this.editDialogVisible = true
				this.setQuestionType(this.editForm.classification)
				
				if(this.questionType===1){
					this.editForm.answer = this.editForm.answer.split(',');
				}
				
				console.log(this.editForm)
			},
			// 监听修改考题对话框的关闭事件
			editDialogClosed() {
				this.$refs.editFormRef.resetFields()
			},

			// 删除按钮
			async removeUserById(id) {
				const confirmResult = await this.$confirm('此操作将永久删除该考题，是否继续？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).catch(err => err)
				if (confirmResult !== 'confirm') {
					return this.$message.info('已取消删除!')
				}
				await this.$http.delete('/subjectss/' + id)
				this.$message.success('考题删除成功!')
				// 刷新
				this.getUserList()
			}
		}
	}
</script>

<style lang="less" scoped>
</style>
